// SortByAndStatusSelectDropdowns.js

import React, { useState } from 'react';
import "../styles/SortByAndStatusSelectDropdowns.css"
import dropdown_open from '../images/dropdown_open.png';
import dropdown_close from '../images/dropdown_close.png';

const SortByAndStatusSelectDropdowns = ({ onStatusChange, onSortByChange }) => {
  const [status, setStatus] = useState('Select status');
  const [sortBy, setSortBy] = useState('Sort By');
  const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false);
  const [isSortByDropdownOpen, setIsSortByDropdownOpen] = useState(false);

  const toggleStatusDropdown = () => setIsStatusDropdownOpen(!isStatusDropdownOpen);
  const toggleSortByDropdown = () => setIsSortByDropdownOpen(!isSortByDropdownOpen);

  const handleStatusSelect = (option) => {
    setStatus(option);
    setIsStatusDropdownOpen(false);
    onStatusChange(option); // Call the function passed as a prop
  };

  const handleSortBySelect = (option) => {
    setSortBy(option);
    setIsSortByDropdownOpen(false);
    onSortByChange(option); // Call the function passed as a prop
  };

  return (
    <div className="moderator-filters">
      {/* Custom Status Dropdown */}
      <div className={`moderator-custom-select ${isStatusDropdownOpen ? "open" : ""}`}>
        <div className="moderator-custom-select-status" onClick={toggleStatusDropdown}>
          {status}
          <span className="moderator-custom-select-arrow">
            {isStatusDropdownOpen ? (
              <img src={dropdown_close} alt="Dropdown Open" className="moderator-dropdown-icon" />
            ) : (
              <img src={dropdown_open} alt="Dropdown Close" className="moderator-dropdown-icon" />
            )}
          </span>
        </div>
        {isStatusDropdownOpen && (
         <div className="moderator-custom-status-options">
            {['All', 'Approved', 'Pending', 'Rejected'].map((option) => (
              <div key={option} className="moderator-custom-select-option" onClick={() => handleStatusSelect(option)}>
                {option}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Custom Sort By Dropdown */}
      <div className={`moderator-custom-select ${isSortByDropdownOpen ? "open" : ""}`}>
        <div className="moderator-custom-select-sortby" onClick={toggleSortByDropdown}>
          {sortBy}
          <span className="moderator-custom-select-arrow">
            {isSortByDropdownOpen ? (
              <img src={dropdown_close} alt="Dropdown Open" className="moderator-dropdown-icon" />
            ) : (
              <img src={dropdown_open} alt="Dropdown Close" className="moderator-dropdown-icon" />
            )}
          </span>
        </div>
        {isSortByDropdownOpen && (
          <div className="moderator-custom-sortby-options">
            {['Latest', 'Oldest'].map((option) => (
              <div key={option} className="moderator-custom-select-option" onClick={() => handleSortBySelect(option)}>
                {option}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SortByAndStatusSelectDropdowns;
